export default "__VITE_ASSET__CwWTgpjm__"